<template>
  <router-view />
</template>

<script>
export default {
  name: "Users",
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>